module.exports = __webpack_public_path__ + "static/media/jumbo1.34b33865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Jumbotron/images/jumbo1.jpg
// module id = 427
// module chunks = 0